import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import { Icon } from '../../Atoms/Icon';

const ButtonDelete = ({ className, iconClassName, ...props }) => {
  return (
    <Button
      {...props}
      variant="link"
      className={classNames(className, 'text-muted')}
    >
      <Icon name="close-circle" className={iconClassName} />
    </Button>
  );
};

ButtonDelete.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
};

export default ButtonDelete;
